export default __webpack_public_path__ + "static/media/icon--fee04.78a750cb.svg";